import { MultiSegmentProgressWrapper, Segment } from "./MultiSegmentProgress.styled";


interface Segment {
    value: number;
    color: string;
}

interface MultiSegmentProgressProps {
    segments: Segment[];
    style?: React.CSSProperties;
}

const MultiSegmentProgress: React.FC<MultiSegmentProgressProps> = ({ segments, style }) => {
    let total = segments.reduce((acc, segment) => acc + segment.value, 0);
    return <MultiSegmentProgressWrapper style={style}>
        {
            segments.map((segment, index) => {
                const width = (100 * segment.value) / total;
                return <Segment key={index} style={{ backgroundColor: segment.color, width: `${width}%` }}></Segment>;
            })
        }
    </MultiSegmentProgressWrapper>
};

export default MultiSegmentProgress;